import { UserApiService } from '@admin/core';
import { UserChangePassword, UserEntity, UserProfile } from '@admin/core/models';
import { ValidatorMatch, ValidatorPassword } from '@admin/shared';
import { formControl, Validators } from '@al00x/forms';
import { Component, inject, signal } from '@angular/core';
import {
  ButtonClickEvent,
  CacBaseDialogComponent,
  CacButtonComponent,
  CacDialogLayoutComponent,
  CacFormBuilderComponent,
  formBuilder,
} from '@controladad/ng-base';
import { of, switchMap } from 'rxjs';

export interface ProfileDialogData {
  user: UserEntity;
}

export type ProfileDialogResult = UserProfile;

@Component({
  selector: 'app-profile-dialog',
  imports: [CacDialogLayoutComponent, CacFormBuilderComponent, CacButtonComponent],
  templateUrl: './profile-dialog.component.html',
})
export class ProfileDialogComponent extends CacBaseDialogComponent<ProfileDialogData, ProfileDialogResult> {
  private readonly userApi = inject(UserApiService);

  userForm = formBuilder({
    cols: 2,
    inputs: {
      firstName: {
        control: formControl<string>(undefined, Validators.required),
        label: 'نام',
      },
      lastName: {
        control: formControl<string>(undefined, Validators.required),
        label: 'نام خانوادگی',
      },
      username: {
        control: formControl<string>(undefined, Validators.required),
        label: 'کد پرسنلی',
      },
    },
  });

  PasswordForm = formBuilder({
    cols: 2,
    inputs: {
      password: {
        control: formControl<string>(undefined, Validators.required),
        label: 'پسورد فعلی',
        colspan: 2,
        inputType: 'password-eye',
      },
      newPassword: {
        control: formControl<string>(undefined, [Validators.required, ValidatorPassword()]),
        label: 'پسورد جدید',
        inputType: 'password-eye',
      },
      repeatNewPassword: {
        control: formControl<string>(undefined, Validators.required),
        label: 'تکرار پسورد جدید',
        inputType: 'password-eye',
      },
    },
    onInit: (controls) => {
      controls.repeatNewPassword.setValidators([Validators.required, ValidatorMatch(controls.newPassword)]);
    },
  });

  changePasswordMode = signal(false);

  constructor() {
    super();
    this.userForm.setValue(this.data.user);
  }

  onToggleChangePassword() {
    const mode = this.changePasswordMode();
    this.changePasswordMode.set(!mode);
  }

  onSubmit(e: ButtonClickEvent) {
    let userValues = this.userForm.getValue();
    if (!userValues) return;
    const userId = this.data.user.id;
    let passwordModel: UserChangePassword;
    if (this.changePasswordMode()) {
      const passwordValues = this.PasswordForm.getValue();
      if (!passwordValues) return;
      passwordModel = {
        password: passwordValues.password,
        newPassword: passwordValues.newPassword,
      };
    }
    this.userApi.updateUser(userId, userValues).pipe(
      switchMap(() => passwordModel ? this.userApi.changePassword(userId, passwordModel) : of(null)),
      switchMap(() => this.userApi.getProfile(userId)),
      e.pipe(),
    ).subscribe((profile) => {
      this.submit(profile);
    });
  }
}
